import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["lockable"]

  connect() {
    this.onStart = (event) => this.lock(event.detail.category)
    this.onEnd = () => this.unlock()
    document.addEventListener("ios-upload:start", this.onStart)
    document.addEventListener("ios-upload:end", this.onEnd)
  }

  disconnect() {
    document.removeEventListener("ios-upload:start", this.onStart)
    document.removeEventListener("ios-upload:end", this.onEnd)
  }

  lock(activeCategory) {
    this.element.dataset.uploading = "true"
    this.element.dataset.uploadingChannel = activeCategory || ""
    this.lockableTargets.forEach((el) => {
      // The active zone keeps its own cancel button + progress bar live;
      // locking it would defeat the cancel affordance.
      if (
        el.dataset.lockableCategory &&
        el.dataset.lockableCategory === activeCategory
      )
        return
      el.dataset.locked = "true"
    })
  }

  unlock() {
    delete this.element.dataset.uploading
    delete this.element.dataset.uploadingChannel
    this.lockableTargets.forEach((el) => {
      delete el.dataset.locked
    })
  }
}
